import { useRemoteComponent } from '@components/Hooks/useRemoteComponent';
import Fader from '@Shared/Fader';
import { IWidget } from '@src/interfaces';
import React from 'react';

interface Props {
  widget: IWidget | undefined
}

const Focus: React.FC<Props> = (props) => {

  if (!props.widget?.expanded_url) {
    return null;
  }

  const [loading, err, Component] = useRemoteComponent(props.widget.expanded_url + '?v' + props.widget.version);

  if (loading) {
    return (
      <div className='widget'
        style={{ padding: '0 5px 8px 4px', position: 'relative', breakInside: 'avoid' }}
      >
        <Fader key='loading'>
          <div style={{ border: 0, position: 'relative' }}>
            <div className='widget-expanded'>
              <h1>{props.widget.title}</h1>
            </div>
          </div>
        </Fader>
      </div>
    );
  }

  if (err != null) {
    return (
      <div>Unknown Error: {err.toString()}</div>
    );
  }

  return (
    <div className='widget'
      style={{ padding: '0 5px 8px 4px', position: 'relative', breakInside: 'avoid' }}
    >
      <div style={{ border: 0, position: 'relative' }}>
        <Component />
      </div>
    </div>
  );
}

export default Focus;